import { useQuery } from "react-query";
import { Client } from "../../autogenerate/api.generated.clients";

export interface CompressorPackingSummaryParams {
    frameSerialNumber?: string;
    startDate?: Date;
    endDate?: Date;
}

export function useCompressorPackingSummary({ frameSerialNumber, startDate, endDate }: CompressorPackingSummaryParams) {
    return useQuery(
        ['compressor-packing-summary', frameSerialNumber, startDate, endDate],
        () => new Client().packingVent_GetPackingVentDataForCompressor(frameSerialNumber!, startDate!.toLocaleString(), endDate!.toLocaleString()),
        {
            enabled: !!frameSerialNumber && !!startDate && !!endDate,
            refetchOnWindowFocus: false
        }
    );
}